
const initialState = {
    isLoading       : false,
    shouldShowLogin : true,
    data            : [],
    error           : false,
};

const processRatesAndOffersSuccess = (state, action) => {
    const { shouldShowLogin, rates } = action.payload;
    return {
        isLoading : false,
        data      : rates,
        shouldShowLogin,
        error     : false,
    };
};

// Error data is not stored in this reducer
const rates = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case 'RATES_AND_OFFERS_REQUEST_START':
        case 'DATA_REQUEST_START':
            return {
                ...state,
                isLoading: true,
            };
        case 'RATES_AND_OFFERS_REQUEST_SUCCESS':
        case 'DATA_REQUEST_SUCCESS':
            return processRatesAndOffersSuccess(state, action);
        case 'RATES_AND_OFFERS_REQUEST_FAILURE':
        case 'DATA_REQUEST_FAILURE':
            return {
                ...state,
                isLoading : false,
                error     : true,
            };
        default:
            return state;
    }
};

export default rates;
